// Pure helper functions for Inventar categorization

// Prioritizare specială pentru magazioner: defectele de pe categoriile critice apar primele.
// Ordine: 1) Mașini de șlefuit, 2) Pikamere, 3) Wassermanagement, 4) Alte categorii cu defect (după nr. defecte desc), 5) Restul alfabetic.
const PRIORITY_PATTERNS = [
  { rank: 1, label: "Mașini de șlefuit", re: /(m[ăa][șs]in[ăa]|maquinas?)\s*de\s*[șs]lefuit|[șs]lefuit|polizor|grinder|sander/i },
  { rank: 2, label: "Pikamere",          re: /pikamer|pickhammer|ciocan\s*(rotoper|demolat)|jackhammer|hilti/i },
  { rank: 3, label: "Wassermanagement",  re: /wassermanagement|wasser|management(ul)?\s*apei|aspirator\s*ap/i },
];

export function categoryPriorityRank(name) {
  for (const p of PRIORITY_PATTERNS) {
    if (p.re.test(name || "")) return p.rank;
  }
  return 99;
}

export function groupItemsByCategory(items) {
  const map = new Map();
  for (const it of items) {
    const baseName = (it.name || "—").trim();
    // Grupare pe model + categorie PSA + mărime, ca fiecare mărime să aibă cardul ei
    // (ex: „ConVic Portocaliu | tricou | M" e separat de „ConVic Portocaliu | tricou | L").
    const cat = (it.psa_category || "").trim();
    const size = (it.psa_size || "").trim();
    const key = `${baseName}|${cat}|${size}`;
    if (!map.has(key)) {
      map.set(key, {
        key,
        name: baseName,
        psa_category: cat || null,
        psa_size: size || null,
        items: [],
      });
    }
    map.get(key).items.push(it);
  }
  const out = Array.from(map.values()).map((g) => {
    const totalQty = g.items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);
    const defectItems = g.items.filter((i) => i.status === "defect");
    const anyDefect = defectItems.length > 0;
    const defectCount = defectItems.length;
    const colors = Array.from(new Set(g.items.map((i) => i.color).filter(Boolean)));
    const types = Array.from(new Set(g.items.map((i) => i.item_type || "echipament")));
    const sample = g.items[0];
    const priorityRank = anyDefect ? categoryPriorityRank(g.name) : 99;
    return { ...g, totalQty, count: g.items.length, anyDefect, defectCount, colors, types, sample, priorityRank };
  });
  // Sortare:
  //   1) Categoriile cu defect au prioritate (anyDefect=true înaintea celor fără)
  //   2) Între cele cu defect, priorityRank ascending (1 → 2 → 3 → 99)
  //   3) În același rank, mai multe defecte = mai sus
  //   4) Tiebreaker: alfabetic
  out.sort((a, b) => {
    if (a.anyDefect !== b.anyDefect) return a.anyDefect ? -1 : 1;
    if (a.priorityRank !== b.priorityRank) return a.priorityRank - b.priorityRank;
    if (a.defectCount !== b.defectCount) return b.defectCount - a.defectCount;
    return a.name.localeCompare(b.name);
  });
  return out;
}
